
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import "../../assets/styles/Footer.css";

export default function Footer() {
    const number = '554792513502';
    const mensagem = 'Olá! Gostaria de saber mais sobre a solução de atendimento.';

  const linkWhatsApp = `https://wa.me/${number}?text=${encodeURIComponent(mensagem)}`;

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <nav className="footer-links">
          <p>
            <FaWhatsapp/>
            <strong> Contato</strong>
            <br />
            <a href={linkWhatsApp} >+55 (47) 9251-3502</a>
          </p>
          <p>
            <FaInstagram />
            <strong> Instagram </strong>
            <br />
            <a href="https://www.instagram.com/summertechai?igsh=enM4Mm9lcm1qaGQ0" >@summertechai </a>
          </p>

          {/* <a href="/sobre">Sobre</a> */}
          {/* <a href="/politica">Política de Privacidade</a> */}
        </nav>
        <span>© {new Date().getFullYear()} Summer Technologies</span>
      </div>
    </footer>
  );
}
